import {Component, OnInit} from '@angular/core';
import {environment} from "../environments/environment";
import {TranslateService} from "ng2-translate";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{

  constructor() {
  }

  ngOnInit(): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts